module.exports = __webpack_public_path__ + "static/fonts/fontawesome-webfont.b06871f.ttf";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/fontawesome-webfont.ttf?v=4.7.0
// module id = 358
// module chunks = 3